import initScrollReveal from "./scripts/scrollReveal";
import initSignalCanvas from "./scripts/signalCanvas";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initSignalCanvas();

// --- Header clock — my local time, ticking. -------------------------------
const clockFormat = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Istanbul",
  hour12: false,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
});

const initClock = () => {
  const node = document.getElementById("utcClock");
  if (!node) return;

  const tick = () => {
    node.textContent = clockFormat.format(new Date());
  };

  tick();
  window.setInterval(tick, 1000);
};

initClock();

// --- ISUP call setup, typed once above the name. ---------------------------
const handshakeStages = [
  "IAM",
  "IAM → ACM",
  "IAM → ACM → ANM",
  "IAM → ACM → ANM · circuit up"
];

const initHandshake = () => {
  const node = document.querySelector("[data-handshake]");
  if (!node) return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const finalStage = handshakeStages[handshakeStages.length - 1];

  if (reduceMotion) {
    node.textContent = finalStage;
    return;
  }

  handshakeStages.forEach((stage, index) => {
    window.setTimeout(() => {
      node.textContent = stage;
    }, 450 + index * 520);
  });
};

initHandshake();

// --- Featured song ----------------------------------------------------------
const featuredSpotifySong = {
  title: "Somnus - Instrumental Version",
  artist: "Yoko Shimomura",
  url: "https://open.spotify.com/track/7fxzqLLTXObxIoTfI3FA0l?si=ce67f14a2bfd4563",
  cover: "https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02c1a3d757e86b84a5b7a68481"
};

const renderFeaturedSpotifySong = () => {
  const card = document.getElementById("spotifyCard");
  const coverNode = document.getElementById("spotifyCover");
  const trackNode = document.getElementById("spotifyTrack");
  const artistNode = document.getElementById("spotifyArtist");

  if (!card || !trackNode || !artistNode) return;

  trackNode.textContent = featuredSpotifySong.title;
  artistNode.textContent = featuredSpotifySong.artist;
  card.href = featuredSpotifySong.url;

  if (coverNode) {
    coverNode.src = featuredSpotifySong.cover;
    coverNode.alt = `${featuredSpotifySong.title} cover`;
  }
};

renderFeaturedSpotifySong();

// --- GTA VI countdown -------------------------------------------------------
const gtaLaunchDate = new Date("2026-11-19T00:00:00-05:00");

const renderGtaCountdown = () => {
  const node = document.getElementById("gtaCountdown");
  if (!node) return;

  const diff = gtaLaunchDate.getTime() - Date.now();

  if (diff <= 0) {
    node.textContent = "It is finally Vice City time.";
    return;
  }

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);

  node.textContent = `${days}d ${hours}h ${minutes}m`;
};

renderGtaCountdown();
window.setInterval(renderGtaCountdown, 60 * 1000);

// --- Learn with me — Wikipedia window ---------------------------------------
const historySubjects = [
  "Finance",
  "Compound interest",
  "Opportunity cost",
  "Financial market",
  "Market liquidity",
  "Trade finance",
  "Venture capital",
  "Risk management",
  "Behavioral economics",
  "Computer programming",
  "Software engineering",
  "Algorithm",
  "Database",
  "Python (programming language)",
  "JavaScript",
  "Management",
  "Strategic management",
  "Operations management",
  "Project management",
  "Supply chain management",
  "Porter's five forces analysis",
  "Artificial intelligence",
  "Machine learning",
  "Large language model",
  "Generative artificial intelligence",
  "Natural language processing",
  "Intelligent agent",
  "Software agent",
  "Multi-agent system",
  "Telecommunications",
  "Mobile network",
  "Voice over IP",
  "Signaling System No. 7",
  "Short Message Service",
  "Short Message Peer-to-Peer",
  "Network effect",
  "Game theory",
  "Economies of scale"
];

const fallbackHistory = {
  title: "Telecommunications",
  extract:
    "Telecommunications is the transmission of information across distance by electronic, optical, radio, or wired systems.",
  image:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 480'%3E%3Crect width='640' height='480' fill='%23050505'/%3E%3Cg stroke='%23f2f2f2' stroke-opacity='.28' fill='none'%3E%3Cpath d='M90 360h460M90 120h460M140 80v320M500 80v320'/%3E%3Cpath d='M140 120l170 120 190-120M140 360l170-120 190 120'/%3E%3Ccircle cx='140' cy='120' r='34'/%3E%3Ccircle cx='500' cy='120' r='34'/%3E%3Ccircle cx='320' cy='240' r='52'/%3E%3Ccircle cx='140' cy='360' r='34'/%3E%3Ccircle cx='500' cy='360' r='34'/%3E%3C/g%3E%3Cg fill='%23f2f2f2'%3E%3Ccircle cx='140' cy='120' r='6'/%3E%3Ccircle cx='500' cy='120' r='6'/%3E%3Ccircle cx='320' cy='240' r='8'/%3E%3Ccircle cx='140' cy='360' r='6'/%3E%3Ccircle cx='500' cy='360' r='6'/%3E%3C/g%3E%3C/svg%3E",
  url: "https://en.wikipedia.org/wiki/Telecommunications"
};

let lastHistorySubject = "";

const pickHistorySubject = () => {
  const options = historySubjects.filter((subject) => subject !== lastHistorySubject);
  const subject = options[Math.floor(Math.random() * options.length)];
  lastHistorySubject = subject;
  return subject;
};

const renderHistorySubject = (entry) => {
  const image = document.getElementById("historyImage");
  const title = document.getElementById("historyTitle");
  const extract = document.getElementById("historyExtract");
  const link = document.getElementById("historyLink");

  if (!image || !title || !extract || !link) return;

  title.textContent = entry.title;
  const starterText =
    entry.extract.length > 260 ? `${entry.extract.slice(0, 257).trim()}...` : entry.extract;

  extract.textContent = starterText;
  link.href = entry.url;
  image.src = entry.image;
  image.alt = `${entry.title} image from Wikipedia`;
};

const loadHistorySubject = async () => {
  const button = document.getElementById("historyRefresh");
  const subject = pickHistorySubject();

  if (button) {
    button.disabled = true;
    button.textContent = "Routing...";
  }

  try {
    const response = await fetch(
      `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(subject)}`
    );

    if (!response.ok) {
      throw new Error("Wikipedia request failed");
    }

    const data = await response.json();
    renderHistorySubject({
      title: data.title || subject,
      extract: data.extract || fallbackHistory.extract,
      image: data.thumbnail?.source || data.originalimage?.source || fallbackHistory.image,
      url: data.content_urls?.desktop?.page || `https://en.wikipedia.org/wiki/${encodeURIComponent(subject)}`
    });
  } catch (error) {
    renderHistorySubject(fallbackHistory);
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = "Change subject";
    }
  }
};

document.getElementById("historyRefresh")?.addEventListener("click", loadHistorySubject);
loadHistorySubject();

// --- YousefGPT — the decorative chat ----------------------------------------
const decorChatReplies = [
  "Hello! This AI chatbot is meant for decoration purposes only. You don’t want me to waste tokens for nothing, so feel free to ask me directly.",
  "I would answer with great artificial wisdom, but this button is mostly here for the atmosphere. Ask Yousef directly and save the tokens.",
  "Decorative AI reporting in. I look intelligent, but today I am just protecting the token budget. Send the real question to Yousef.",
  "I asked the server for a deep answer, but it said we are on a budget. Yousef will do a better job anyway."
];

const decorChatUsageKey = "0xyousef.decorativeChatUsed";
let yousefGptCountry = "";

const detectDeviceType = () => {
  const ua = navigator.userAgent || "";
  const hasTouch = navigator.maxTouchPoints > 1;

  if (/ipad|tablet|kindle|playbook|silk/i.test(ua)) return "Tablet";
  if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return "Phone";
  if (hasTouch && Math.min(window.innerWidth, window.innerHeight) >= 700) return "Tablet";
  return "Desktop";
};

const loadYousefGptCountry = async () => {
  try {
    const response = await fetch("https://ipapi.co/json/", { cache: "no-store" });
    if (!response.ok) throw new Error("Country lookup failed");

    const data = await response.json();
    const countryName = data.country_name || "";
    const countryCode = data.country_code ? ` (${data.country_code})` : "";
    yousefGptCountry = countryName ? `${countryName}${countryCode}` : data.country || "";
  } catch (error) {
    yousefGptCountry = "Unavailable";
  }
};

loadYousefGptCountry();

const hasDecorChatUsage = () => {
  try {
    return window.sessionStorage?.getItem(decorChatUsageKey);
  } catch (error) {
    return document.documentElement.dataset.decorChatUsed;
  }
};

const setDecorChatUsage = () => {
  document.documentElement.dataset.decorChatUsed = "true";

  try {
    window.sessionStorage?.setItem(decorChatUsageKey, "true");
  } catch (error) {
    // The dataset flag keeps the one-message limit during this page view.
  }
};

const submitYousefGptMessage = async (message) => {
  const formData = new URLSearchParams();
  const createdAt = new Date().toISOString();
  const country = yousefGptCountry || "Pending";
  const deviceType = detectDeviceType();

  formData.append("form-name", "yousefgpt");
  formData.append("message", message);
  formData.append("page", window.location.href);
  formData.append("language", navigator.language || "");
  formData.append("country", country);
  formData.append("deviceType", deviceType);
  formData.append("userAgent", navigator.userAgent || "");
  formData.append("createdAt", createdAt);

  await fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: formData.toString()
  });
};

const appendDecorChatBubble = (container, text, type) => {
  const bubble = document.createElement("p");
  bubble.className = `decor-chat__bubble decor-chat__bubble--${type}`;
  bubble.textContent = text;
  container.appendChild(bubble);
  container.scrollTop = container.scrollHeight;
};

const initDecorChat = () => {
  const widget = document.querySelector("[data-chat-widget]");
  const toggle = document.querySelector("[data-chat-toggle]");
  const close = document.querySelector("[data-chat-close]");
  const panel = document.querySelector("[data-chat-panel]");
  const form = document.querySelector("[data-chat-form]");
  const input = document.querySelector("[data-chat-input]");
  const messages = document.querySelector("[data-chat-messages]");
  const pageInput = document.querySelector("[data-chat-page]");
  const languageInput = document.querySelector("[data-chat-language]");
  const countryInput = document.querySelector("[data-chat-country]");
  const deviceTypeInput = document.querySelector("[data-chat-device-type]");
  const userAgentInput = document.querySelector("[data-chat-user-agent]");
  const createdAtInput = document.querySelector("[data-chat-created-at]");

  if (!widget || !toggle || !panel || !form || !input || !messages) return;

  const setOpen = (isOpen) => {
    panel.hidden = !isOpen;
    toggle.setAttribute("aria-expanded", String(isOpen));
    if (isOpen) input.focus();
  };

  toggle.addEventListener("click", () => setOpen(panel.hidden));
  close?.addEventListener("click", () => setOpen(false));

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const message = input.value.trim();
    if (!message) return;

    appendDecorChatBubble(messages, message, "user");

    if (pageInput) pageInput.value = window.location.href;
    if (languageInput) languageInput.value = navigator.language || "";
    if (countryInput) countryInput.value = yousefGptCountry || "Pending";
    if (deviceTypeInput) deviceTypeInput.value = detectDeviceType();
    if (userAgentInput) userAgentInput.value = navigator.userAgent || "";
    if (createdAtInput) createdAtInput.value = new Date().toISOString();

    submitYousefGptMessage(message).catch(() => {
      // Netlify Forms receives this on the live site; localhost may reject POST.
    });

    input.value = "";

    if (hasDecorChatUsage()) {
      appendDecorChatBubble(
        messages,
        "Usage limit has been reached for now. Try again later.",
        "bot"
      );
      return;
    }

    setDecorChatUsage();
    const reply = decorChatReplies[Math.floor(Math.random() * decorChatReplies.length)];
    appendDecorChatBubble(messages, reply, "bot");
  });
};

initDecorChat();

const initPrivacyModal = () => {
  const modal = document.querySelector("[data-privacy-modal]");
  const openButtons = document.querySelectorAll("[data-privacy-open]");
  const closeButtons = document.querySelectorAll("[data-privacy-close]");

  if (!modal || !openButtons.length) return;

  const setOpen = (isOpen) => {
    modal.hidden = !isOpen;
    document.body.classList.toggle("privacy-modal-open", isOpen);
  };

  openButtons.forEach((button) => {
    button.addEventListener("click", () => setOpen(true));
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.hidden) {
      setOpen(false);
    }
  });
};

initPrivacyModal();
